import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminShell from "../components/admin/AdminShell";
import { apiFetch, useAuth } from "../hooks/useAuth";

const inputCls =
  "w-full bg-transparent border border-navy/18 px-4 py-4 font-sans text-[16px] text-navy focus:outline-none focus:border-navy transition-colors duration-300";

const AdminLogin = () => {
  const nav = useNavigate();
  const { loading, user } = useAuth();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && user) nav("/admin/submissions");
  }, [loading, user, nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await apiFetch("/api/admin/login", {
        method: "POST",
        body: JSON.stringify({ username: u, password: p }),
      });
      if (!res.ok) {
        setError("The credentials provided were not recognised.");
        setBusy(false);
        return;
      }
      nav("/admin/submissions");
    } catch {
      setError("The credentials provided were not recognised.");
      setBusy(false);
    }
  };

  return (
    <AdminShell user={null}>
      <div className="mx-auto" style={{ maxWidth: 420 }}>
        <span
          className="font-sans uppercase text-gold"
          style={{ fontSize: "11px", letterSpacing: "0.22em" }}
        >
          Office Console
        </span>
        <h1
          className="mt-6 font-serif font-normal text-navy"
          style={{ fontSize: "clamp(32px, 3vw, 48px)", lineHeight: 1.1, letterSpacing: "-0.01em" }}
        >
          Sign in.
        </h1>
        <span aria-hidden="true" className="mt-8 block h-px w-8 bg-gold" />

        <form onSubmit={onSubmit} noValidate className="mt-10 flex flex-col gap-6" aria-live="polite">
          <div>
            <label htmlFor="al-user" className="font-sans uppercase text-navy/70 block mb-3" style={{ fontSize: "11px", letterSpacing: "0.22em" }}>
              Username
            </label>
            <input id="al-user" data-testid="login-username" value={u} onChange={(e) => setU(e.target.value)} autoComplete="username" className={inputCls} style={{ borderRadius: 2, minHeight: 56 }} />
          </div>
          <div>
            <label htmlFor="al-pass" className="font-sans uppercase text-navy/70 block mb-3" style={{ fontSize: "11px", letterSpacing: "0.22em" }}>
              Password
            </label>
            <input id="al-pass" data-testid="login-password" type="password" value={p} onChange={(e) => setP(e.target.value)} autoComplete="current-password" className={inputCls} style={{ borderRadius: 2, minHeight: 56 }} />
          </div>
          {error ? (
            <p data-testid="login-error" className="font-sans text-navy/80" style={{ fontSize: "13px" }}>
              {error}
            </p>
          ) : null}
          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit"
            className="group relative inline-flex items-center justify-center px-7 py-3.5 border border-navy/70 hover:border-gold text-navy font-sans uppercase transition-colors duration-300 disabled:opacity-60 self-start"
            style={{ fontSize: "11px", letterSpacing: "0.22em" }}
          >
            <span className="relative">
              {busy ? "Signing in…" : "Continue"}
              <span aria-hidden="true" className="absolute left-0 right-0 -bottom-1 h-px bg-gold scale-x-0 origin-left transition-transform duration-300 ease-out group-hover:scale-x-100" />
            </span>
          </button>
        </form>
      </div>
    </AdminShell>
  );
};

export default AdminLogin;
